export default "__VITE_ASSET__DtLARZC6__"